import * as React from "react";
import {
	PeripheralHealthCheckReason,
	PeripheralHealthCheckStatus,
} from "../../../../../backend/shared/types/peripheralHealthCheck";
import "./device-descriptor.scss";

type DeviceDescriptorProps = {
	loading: boolean;
	status: PeripheralHealthCheckStatus;
	reason: PeripheralHealthCheckReason;
	img: string;
	text: string;
};

export const DeviceDescriptor: React.FC<DeviceDescriptorProps> = ({ loading, status, reason, img, text }) => {
	const statusMessage = React.useMemo(() => {
		if (!status || status === PeripheralHealthCheckStatus.PENDING) {
			return "Waiting on response";
		}

		if (status === PeripheralHealthCheckStatus.PASSED) {
			return "Connected";
		}

		if (status === PeripheralHealthCheckStatus.FAILED && reason === PeripheralHealthCheckReason.TIMEOUT) {
			return "Failed to respond";
		}

		return "Responded with error";
	}, [loading, status, reason]);

	return (
		<div data-qa="device-descriptor" className={`device device--${status ?? "loading"}`}>
			<div className="device__image">
				{/* rome-ignore lint/a11y/useAltText: <explanation> */}
				<img src={img} />
			</div>

			<div className="device__peripheral">
				<p data-qa="device-descriptor-title">{text}</p>

				<div className="device__peripheral__status">
					<p data-qa="device-status-message" className={`${status ?? "loading"}`}>
						{statusMessage}
					</p>
				</div>
			</div>
		</div>
	);
};
